import React, { useState } from 'react';
import { DevErrorModal } from '~/components/Errors/DevErrorModal';
import { useServiceSubscribe } from '~/util';
import { EventService } from '~/services';

function ApiErrorListener() {
    const [errors, setErrors] = useState<CustomError[]>([]);

    function handleApiError(response: ApiErrorResponseType) {
        setErrors((prevErrors) => [
            ...prevErrors,
            response
                ? {
                      response,
                      details: {
                          method: response.config!.method,
                          url: response.config!.url,
                          status: response.status,
                          request: {
                              params: response.config!.params,
                              data: response.config!.data,
                          },
                          responseData: response.data,
                          date: response.headers!.date!,
                      },
                  }
                : {
                      response: { status: 1, statusText: 'A network error occurred' },
                      details: { date: new Date().getTime() },
                  },
        ]);
    }

    useServiceSubscribe(EventService.EVENTS.api_error, handleApiError);
    // Treat update_collision and api_error the same for now
    useServiceSubscribe(EventService.EVENTS.update_collision, handleApiError);

    return (
        <>
            {errors.map((error) => (
                <DevErrorModal error={error} key={error.details!.date} />
            ))}
        </>
    );
}

export { ApiErrorListener };
